module.exports = __webpack_public_path__ + "img/img1.a77efc61.jpg";